const NavbarMenuItems = [
  {
    name: 'Dashboard',
    icon: 'dashboard',
    url: '/overview/',
  },
  {
    name: 'Coupons',
    icon: 'credit_card',
    url: '/coupons/',
  },
  {
    name: 'Passes',
    icon: 'card_membership',
    url: '/passes/',
  },
  {
    name: 'Complaints',
    icon: 'warning_amber',
    url: '/complaints/',
  },
  {
    name: 'Properties',
    icon: 'apartment',
    group: true,
    roles: [],
    items: [
      {
        name: 'Pending Approval',
        icon: 'fact_check',
        url: '/property/approvals/'
      },
      {
        name: 'Live',
        icon: 'location_city',
        url: '/property/live/'
      },
    ]
  },
  {
    name: 'Bookings',
    icon: 'date_range',
    roles: [],
    url: '/bookings/'
  },
  {
    name: 'Earnings',
    icon: 'account_balance_wallet',
    roles: [],
    url: '/earnings/'
  },
  {
    name: 'Enquiries',
    icon: 'forum',
    roles: [],
    url: '/enquiries/'
  },
  {
    name: 'Guest Reviews',
    icon: 'reviews',
    roles: [],
    url: '/guest-reviews/'
  },
  {
    name: 'Reports',
    icon: 'summarize',
    group: true,
    roles: [],
    items: [
      {
        name: 'Booking',
        icon: 'date_range',
        url: '/reports/booking/'
      },
      {
        name: 'Incentive',
        icon: 'account_balance_wallet',
        url: '/reports/incentive/'
      },
      {
        name: 'Payout',
        icon: 'payments',
        url: '/reports/payout/'
      },
      {
        name: 'Enquiry',
        icon: 'forum',
        url: '/reports/enquiry/'
      },
    ]
  },
  // {
  //   name: 'Operations',
  //   subHeading: true,
  // },
  {
    name: 'Operations',
    icon: 'build_circle',
    group: true,
    roles: [],
    items: [
      {
        name: 'Revenue Sharing',
        icon: 'share',
        url: '/operations/revenue-sharing/'
      },
      {
        name: 'Dynamic Pricing',
        icon: 'toll',
        url: '/operations/dynamic-pricing/'
      },
    ]
  },
  {
    name: 'Help & Support',
    icon: 'support_agent',
    roles: [],
    url: '/support/'
  },
  {
    name: 'Feedback',
    icon: 'rate_review',
    roles: [],
    url: '/feedback/'
  },
  // {
  //   name: 'Users',
  //   icon: 'groups',
  //   group: true,
  //   roles: ['admin', 'manager', 'employee'],
  //   items: [
  //     {
  //       name: 'Search',
  //       icon: 'person_search',
  //       url: '/user/search/'
  //     },
  //     {
  //       name: 'Add',
  //       icon: 'group_add',
  //       url: '/user/add/'
  //     },
  //   ]
  // },
  // {
  //   name: 'Manage PG',
  //   icon: 'maps_home_work',
  //   group: true,
  //   roles: ['admin', 'manager', 'employee'],
  //   items: [
  //     {
  //       name: 'Search',
  //       icon: 'manage_search',
  //       url: '/pg/search/'
  //     },
  //     {
  //       name: 'Add',
  //       icon: 'house',
  //       url: '/pg/add/'
  //     },
  //   ]
  // },
];

export default NavbarMenuItems;
